module.exports = __webpack_public_path__ + "img/client-4.45857aa2.jpg";